const DATE_BY_CARD_ID = Object.freeze({
  'story-1': '2026-09-30',
  'enabler-1': '2026-12-15',
  'bug-1': '2026-09-12',
  'story-2': '2026-10-10',
  'poc-1': '2027-01-20',
  'story-3': '2026-11-01',
});

const DATE_FIELD = Object.freeze({
  key: 'dueDate',
  label: 'Prazo',
  type: 'date',
  ruleType: 'date',
});

export const withDateRuleExamples = (data = {}) => ({
  ...data,
  cardTypes: (data.cardTypes || []).map((type) => {
    if (Number(type?.level) !== 2) return type;
    if ((type.fields || []).some((field) => field?.key === DATE_FIELD.key)) return type;
    return { ...type, fields: [...(type.fields || []), { ...DATE_FIELD }] };
  }),
  columns: (data.columns || []).map((column) => ({
    ...column,
    cards: (column.cards || []).map((card) => {
      const dueDate = DATE_BY_CARD_ID[card?.id];
      if (!dueDate) return card;
      const metadata = (card.metadata || []).filter((item) => item?.key !== DATE_FIELD.key);
      return {
        ...card,
        dueDate,
        metadata: [...metadata, { ...DATE_FIELD, value: dueDate }],
      };
    }),
  })),
});

export const tutorialRulesByLevel = Object.freeze({
  2: [
    {
      id: 'blocked-tag',
      name: 'Bloqueado',
      enabled: true,
      color: 'danger',
      criteria: [
        { id: 'blocked-tag-criterion', fieldKey: 'tags', operator: 'contains', value: 'Bloqueado' },
      ],
    },
    {
      id: 'attention-tag',
      name: 'Atenção',
      enabled: true,
      color: 'warning',
      criteria: [
        { id: 'attention-tag-criterion', fieldKey: 'tags', operator: 'contains', value: 'Atenção' },
      ],
    },
    {
      id: 'missing-story-points',
      name: 'Sem Story Points',
      enabled: true,
      color: 'info',
      criteria: [
        { id: 'missing-story-points-criterion', fieldKey: 'storyPoints', operator: 'empty', value: '' },
      ],
    },
    {
      id: 'date-relative-example',
      name: 'Prazo nos próximos 90 dias',
      enabled: false,
      color: '#00A8E8',
      criteria: [
        { id: 'date-relative-example-criterion', fieldKey: 'dueDate', operator: 'lessThan', value: '@Today + 90' },
      ],
    },
    {
      id: 'date-fixed-example',
      name: 'Prazo em 30/09/2026',
      enabled: false,
      color: '#FFC400',
      criteria: [
        { id: 'date-fixed-example-criterion', fieldKey: 'dueDate', operator: 'equals', value: '2026-09-30' },
      ],
    },
  ],
});